import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { CandidateProfileDetail } from 'modules/candidate-profile/components/CandidateProfileDetail';
import { CandidateProfileDetailType } from 'modules/candidate-profile/types/CandidateProfileDetailProps';

export const CandidateProfileDetailsPage: React.FC = () => {
  const { getPathParams } = usePathsV2();
  const { candidateProfileId } = getPathParams.CANDIDATE_PROFILE_DETAILS();

  return (
    <CandidateProfileDetail
      type={CandidateProfileDetailType.CANDIDATE_PROFILE_DETAILS}
      candidateProfileId={candidateProfileId}
    />
  );
};
